const PaasSearchOverlay = () => {
  return (
    <>
      <div className="paas search-overlay" data-search-overlay="">
        <span className="close-search" aria-label="Close">
          Close
        </span>
        <form
          action="https://www.fhnw.ch/plattformen/generisch/"
          className="search-form"
          data-search-form=""
          method="get"
        >
          <div className="search-box-wrapper">
            <label className="sr-only" htmlFor="5d7f4eb39af7d">
              Geben Sie Ihren Suchbegriff ein
            </label>
            <input
              aria-label="Geben Sie Ihren Suchbegriff ein"
              className="field"
              data-search-input=""
              name="s"
              placeholder="Geben Sie Ihren Suchbegriff ein"
              type="text"
              id="5d7f4eb39af7d"
              autoComplete="off"
            />
            <a id="search-submit" type="submit">
              <svg
                className="enter-icon"
                data-search-enter-icon="enter-icon"
                height="64"
                viewBox="0 0 484.5 484.5"
                width="64"
              >
                <path d="M433.5 114.75v102H96.9l91.8-91.8-35.7-35.7-153 153 153 153 35.7-35.7-91.8-91.8h387.6v-153z"></path>
              </svg>
            </a>
          </div>
        </form>
      </div>
    </>
  );
};

export default PaasSearchOverlay;
